module.exports = __webpack_public_path__ + "img/mapgis_npm.7bcb5280.jpeg";